import React, { useEffect, useRef } from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
// import ReactPixel from 'react-facebook-pixel';
import { v4 as uuidv4 } from 'uuid';

import './config/ReactotronConfig';
import { Router } from 'react-router-dom';
import GlobalStyle from './styles/global';
import history from './services/history';
import Routes from './routes';
// eslint-disable-next-line import/no-extraneous-dependencies

import { store, persistor } from './store';
import MigrationBanner from './components/MigrationBanner';
import { ConversionApiMeta, getFbc, getFbp } from './functions/meta';
import { ConversionApiTiktok, getTtclid, getTtp } from './functions/tiktok';

// import { getVstId } from './functions/tracking';
import api from './services/api';
import { initializePixels } from './functions/tracking';

function App() {
  const lastPathRef = useRef(window.location.pathname);

  // Função para disparar o PageView
  const trackPageView = async () => {
    const uuid = uuidv4();
    const state = store && store.getState();

    if (state && state.user && state.user.profile) {
      const { id, email, whatsapp, name } = store.getState().user.profile;

      if (typeof window.FS === 'function') {
        window.FS('setIdentity', {
          uid: id, // aqui tu pode usar o id do usuário da tua app
          properties: {
            displayName: name,
            email,
            reviewsWritten: 14,
          },
        });
      }

      const userregistrationtracking = await api.get(
        '/userregistrationtracking'
      );

      // const vst_id = await getVstId(userregistrationtracking);
      const fbc = await getFbc(userregistrationtracking);
      const fbp = await getFbp(userregistrationtracking);
      const ttclid = await getTtclid(userregistrationtracking);
      const ttp = await getTtp(userregistrationtracking);

      if (typeof window.fbq === 'function') {
        window.fbq(
          'track',
          'PageView',
          {
            external_id: id,
            fbc,
            fbp,
          },
          {
            eventID: uuid,
          }
        );
      }

      if (typeof window.ttq?.track === 'function') {
        window.ttq.track('Pageview', {
          eventID: uuid,
          external_id: id,
          ttclid,
          ttp,
        });
      }

      await ConversionApiMeta({
        eventId: uuid,
        eventName: 'PageView',
        email,
        phone: whatsapp,
        externalId: id,
        fbc,
        fbp,
      });

      await ConversionApiTiktok({
        eventId: uuid,
        eventName: 'Pageview',
        email,
        phone: whatsapp,
        externalId: id,
        ttclid,
        ttp,
      });
    } else {
      const fbc = await getFbc(null);
      const fbp = await getFbp(null);
      const ttclid = await getTtclid(null);
      const ttp = await getTtp(null);

      if (typeof window.fbq === 'function') {
        window.fbq(
          'track',
          'PageView',
          {
            external_id: uuid,
            fbc,
            fbp,
          },
          {
            eventID: uuid,
          }
        );
      }

      if (typeof window.ttq?.track === 'function') {
        window.ttq.track('Pageview', {
          eventID: uuid,
          external_id: uuid,
          ttclid,
          ttp,
        });
      }

      await ConversionApiMeta({
        eventName: 'PageView',
        eventId: uuid,
        externalId: uuid,
        fbc,
        fbp,
      });

      await ConversionApiTiktok({
        eventName: 'Pageview',
        eventId: uuid,
        externalId: uuid,
        ttclid,
        ttp,
      });
    }
  };

  useEffect(() => {
    async function load() {
      // const params = new URLSearchParams(window.location.search);
      // const fbclid = params.get('fbclid');
      // const ttclid = params.get('ttclid');

      // ReactPixel.init('1775048205980627');
      await initializePixels();
      // Dispara o PageView inicial
      await trackPageView();
    }

    load();

    // Escuta mudanças de rota
    const unlisten = history.listen(location => {
      const currentPath = location.pathname;

      // Só dispara se a rota realmente mudou
      if (lastPathRef.current !== currentPath) {
        lastPathRef.current = currentPath;
        trackPageView();
      }
    });

    return () => {
      unlisten();
    };
  }, []);

  useEffect(() => {
    // let deferredPrompt;

    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault();
      // deferredPrompt = e;

      // Ex: salvar no global ou localStorage
      window.deferredPWAInstall = e;
    });
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <GlobalStyle />
          <ToastContainer
            position="top-center"
            autoClose={1500}
            limit={1}
            hideProgressBar
            transition={Slide}
          />
          <MigrationBanner />
          <Routes />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
